import { TRADEMASTER__MUTATIONS } from "../mutation-types";
import { TRADEMASTER__ACTIONS } from '../action-types'
import { TRADEMASTER__API } from '@/_helpers/urls'
import http from "@/_helpers/http";
import toast from "@/services/Notification";

// State
const state = {
    investorAccounts: [],
    affiliateSummary: {},
    accountDetails: {
        liveAccounts: {},
        investor_referral_link: ""
    },
    levelClients: {
        total_clients: 0,
        total_commission: 0,
        clients: [],
    },
    mt5AllTransactions: []

};

const getters = {};

// Mutations
const mutations = {
    [TRADEMASTER__MUTATIONS.INVESTORACCOUNTS](state, data) {
        state.investorAccounts = data;
    },
    [TRADEMASTER__MUTATIONS.AFFILIATESUMMARY](state, data) {
        state.affiliateSummary = data;
    },
    [TRADEMASTER__MUTATIONS.MT5ACCOUNTDETAILS](state, data) {
        state.accountDetails.liveAccounts = data.liveAccounts;
        state.accountDetails.investor_referral_link = data.investor_referral_link;
    },
    [TRADEMASTER__MUTATIONS.LEVELCLIENTS](state, data) {
        state.levelClients.total_clients = data.total_clients;
        state.levelClients.total_commission = data.total_commission;
        state.levelClients.clients = data.clients;
    },
    [TRADEMASTER__MUTATIONS.MT5TRANSACTIONS](state, data) {
        state.mt5AllTransactions = data.allTransactions;
    },
};

// Actions
const actions = {
    async [TRADEMASTER__ACTIONS.INVESTORACCOUNTS]({ commit }) {
        try {
            const response = await http().get(TRADEMASTER__API.INVESTORACCOUNTS);

            if (response.status === 200) {
                commit(TRADEMASTER__MUTATIONS.INVESTORACCOUNTS, response.data);
            } else {
                const errorMessage = response.data.message;
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error("An error occurred while fetching investor accounts:", error);
        }
    },

    async [TRADEMASTER__ACTIONS.AFFILIATESUMMARY]({ commit }, parameter) {
        try {
            const response = await http().get(`${TRADEMASTER__API.AFFILIATESUMMARY}/${parameter}`);

            if (response.status === 200) {
                commit(TRADEMASTER__MUTATIONS.AFFILIATESUMMARY, response?.data?.data);
            } else {
                const errorMessage = response.data.message;
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error("An error occurred while fetching affiliate summary:", error);
        }
    },

    async [TRADEMASTER__ACTIONS.MT5ACCOUNTDETAILS]({ commit }, parameter) {
        try {
            const response = await http().get(`${TRADEMASTER__API.MT5ACCOUNTDETAILS}/${parameter}`);

            if (response.status === 200) {
                commit(TRADEMASTER__MUTATIONS.MT5ACCOUNTDETAILS, response?.data);
            } else {
                const errorMessage = response.data.message;
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error("An error occurred while fetching account details:", error);
        }
    },

    async [TRADEMASTER__ACTIONS.LEVELCLIENTS]({ commit }, parameter) {
        try {
            const response = await http().get(`${TRADEMASTER__API.LEVELCLIENTS}?id=${parameter}`);

            if (response.status === 200) {
                commit(TRADEMASTER__MUTATIONS.LEVELCLIENTS, response?.data?.data);
            } else {
                const errorMessage = response.data.message;
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error("An error occurred while fetching level clients:", error);
        }
    },

    async [TRADEMASTER__ACTIONS.MT5TRANSACTIONS]({ commit }, parameter) {
        try {
            const response = await http().get(`${TRADEMASTER__API.MT5TRANSACTIONS}?id=${parameter}`);

            if (response.status === 200) {
                commit(TRADEMASTER__MUTATIONS.MT5TRANSACTIONS, response.data);
            } else {
                const errorMessage = response.data.message;
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error("An error occurred while fetching transactions:", error);
        }
    },
};

export default {
    strict: process.env.NODE_ENV !== "production",
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
